// UserSession.ts
import { postObject } from "../ChoiceApi";

// Update the session
export async function Rendering(payload: WindowSearchRenderingInputs): Promise<WindowSearchRenderingResponse|undefined> {
    return await postObject("api/WindowSearch/Rendering", payload);
} 

export async function Patient(payload: WindowSearchPatientInputs): Promise<WindowSearchPatientResponse|undefined> {
    return await postObject("api/WindowSearch/Patient", payload);
} 

export enum WindowSearchAdditionalPlacement {
    Top,
    Right,
    Left
}

export enum WindowSearchDropdownAlignment {
    Left,
    Right
}

export interface WindowSearchRenderingInputs
{
    searchText: string, 
    onlyRendering: boolean
}

export interface WindowSearchRenderingListItem
{
    billingProviderId: number, 
    providerName: string,
    active?: boolean | string,
    npi?: string
}

export interface WindowSearchRenderingResponse
{
    totalRows: number,
    maxReturnRows: number,
    searchList: WindowSearchRenderingListItem[]
}

export interface WindowSearchColumnNameItem {
    columnName: string,
    tooltip: string,
    width?: string
}

export interface WindowSearchPatientInputs
{
    searchText: string
}

export interface WindowSearchPatientListItem
{
    patientId: number, 
    patientEid?: number,
    patientName: string,
    birthDate?: string,
    age?: string,
    gender?: string,
    commentGroupId?: number
}

export interface WindowSearchPatientResponse
{
    totalRows: number,
    maxReturnRows: number,
    searchList: WindowSearchPatientListItem[]
}